(function () {
  'use strict';

  var errorBanner = document.getElementById('formError');

  function showError(msg) {
    if (errorBanner) {
      errorBanner.textContent = msg;
      errorBanner.hidden = false;
    }
  }

  function clearError() {
    if (errorBanner) {
      errorBanner.textContent = '';
      errorBanner.hidden = true;
    }
  }

  function createDropzone(config) {
    var zone = document.getElementById(config.zoneId);
    var input = document.getElementById(config.inputId);
    var list = document.getElementById(config.listId);
    var files = [];

    if (zone) {
      zone.addEventListener('dragover', function (e) {
        e.preventDefault();
        zone.classList.add('dragover');
      });
      zone.addEventListener('dragleave', function () {
        zone.classList.remove('dragover');
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('dragover');
        addFiles(e.dataTransfer.files);
      });
    }

    if (input) {
      input.addEventListener('change', function () { addFiles(input.files); });
    }

    function addFiles(newFiles) {
      for (var i = 0; i < newFiles.length; i++) {
        var file = newFiles[i];
        if (file.size > 25 * 1024 * 1024) {
          showError(file.name + ' is too large. Maximum file size is 25 MB.');
          continue;
        }
        if (!files.some(function (f) { return f.name === file.name && f.size === file.size; })) {
          files.push(file);
        }
      }
      render();
    }

    function render() {
      if (!list) return;
      list.textContent = '';
      if (zone) zone.classList.toggle('has-files', files.length > 0);

      files.forEach(function (file, i) {
        var size = (file.size / 1024 / 1024).toFixed(1);
        var item = document.createElement('div');
        item.className = 'pa-file-item';

        var span = document.createElement('span');
        span.textContent = file.name + ' (' + size + ' MB)';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Remove ' + file.name);
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        btn.addEventListener('click', function () {
          files.splice(i, 1);
          render();
        });

        item.appendChild(span);
        item.appendChild(btn);
        list.appendChild(item);
      });
    }

    return { getFiles: function () { return files; } };
  }

  var invoices = createDropzone({ zoneId: 'dropzone', inputId: 'fileInput', listId: 'fileList' });

  var form = document.getElementById('auditForm');
  var submitBtn = document.getElementById('submitBtn');
  var uploadCard = document.getElementById('uploadCard');
  var successMessage = document.getElementById('successMessage');
  var formEndpoint = form && form.dataset.endpoint;

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      if (invoices.getFiles().length === 0) {
        showError('Please upload at least one invoice.');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      if (formEndpoint) {
        var formData = new FormData();
        formData.append('company', form.company.value);
        formData.append('email', form.email.value);
        invoices.getFiles().forEach(function (f) { formData.append('invoices', f); });

        fetch(formEndpoint, { method: 'POST', body: formData })
          .then(function (res) {
            if (!res.ok) throw new Error('Server responded ' + res.status);
            showSuccess();
          })
          .catch(function (err) {
            console.error('Audit form error:', err);
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit for FREE audit';
            showError('Something went wrong. Please try again or email us directly.');
          });
      } else {
        setTimeout(showSuccess, 1500);
      }
    });
  }

  function showSuccess() {
    if (uploadCard) uploadCard.style.display = 'none';
    if (successMessage) {
      successMessage.hidden = false;
      successMessage.classList.add('show');
    }
  }

  document.querySelectorAll('.pa-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.pa-faq__question').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.nextElementSibling.setAttribute('hidden', '');
      });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }
    });
  });

  // Quote carousel
  var slides = document.querySelectorAll('.pa-quotes__slide');
  var dots = document.querySelectorAll('.pa-quotes__dot');
  var currentSlide = 0;
  var autoplayInterval;

  function goToSlide(index) {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');
    currentSlide = index;
    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
  }

  function nextSlide() {
    goToSlide((currentSlide + 1) % slides.length);
  }

  if (slides.length > 1) {
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToSlide(i);
        clearInterval(autoplayInterval);
        autoplayInterval = setInterval(nextSlide, 5000);
      });
    });
    autoplayInterval = setInterval(nextSlide, 5000);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });

})();
